
export default {
    getIdioma(state) {
        return state.idioma;
    },
    getIdiomas(state) {
        return state.idiomas;
    },
}